"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const eachDayOfInterval_1 = __importDefault(require("date-fns/eachDayOfInterval"));
const format_1 = __importDefault(require("date-fns/format"));
const isAfter_1 = __importDefault(require("date-fns/isAfter"));
const isBefore_1 = __importDefault(require("date-fns/isBefore"));
const isEqual_1 = __importDefault(require("date-fns/isEqual"));
const isToday_1 = __importDefault(require("date-fns/isToday"));
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const id_1 = __importDefault(require("date-fns/locale/id"));
const ms_1 = __importDefault(require("date-fns/locale/ms"));
const th_1 = __importDefault(require("date-fns/locale/th"));
const vi_1 = __importDefault(require("date-fns/locale/vi"));
const ja_1 = __importDefault(require("date-fns/locale/ja"));
const ko_1 = __importDefault(require("date-fns/locale/ko"));
function getLocale(locale) {
    switch (locale) {
        case 'id':
            return id_1.default;
        case 'ms':
            return ms_1.default;
        case 'th':
            return th_1.default;
        case 'vi':
            return vi_1.default;
        case 'ja':
            return ja_1.default;
        case 'ko':
            return ko_1.default;
        default:
            if (__DEV__ && locale !== 'en')
                console.warn(`'${locale}' locale is not supported, fallback to 'en' locale.`);
            return en_US_1.default;
    }
}
function dateToString(date, dateFormat = 'd MMMM yyyy', options = { locale: 'en' }) {
    const formatOptions = {
        locale: getLocale(options.locale),
    };
    return (0, format_1.default)(date, dateFormat, formatOptions);
}
exports.default = {
    getLocale,
    dateToString,
    isBefore: isBefore_1.default,
    isEqual: isEqual_1.default,
    isAfter: isAfter_1.default,
    isToday: isToday_1.default,
    eachDayOfInterval: eachDayOfInterval_1.default,
};
